import ListResultPreview from './ListResultPreview';

export default function ListResults({ results }) {
	return (
		<div class="w-full">
			<div class="hidden md:flex text-sm text-muted font-display font-bold gap-x-5 pb-2">
				<p class="w-2/12">Navn/tittel</p>
				<p class="w-4/12 whitespace-nowrap">
					<i class="far fa-industry-alt mr-1.5"></i>
					Næring
				</p>
				<p class="w-2/12 whitespace-nowrap">
					<i class="far fa-fish mr-1.5"></i>
					Arter
				</p>
				<p class="w-1/12 whitespace-nowrap">
					<i class="far fa-map-marker-alt mr-1.5"></i>
					Fylke
				</p>
				<p class="w-3/12"></p>
			</div>
			<div class="flex flex-col border-t border-gray">
				{results?.map(result => <ListResultPreview item={result} />)}
			</div>
		</div>
	);
}
